import { mString } from 'lib/helpers/utility';
import numOrDefault from 'lib/helpers/numOrDefault';
import { COMPLETED_TRANSACTION_STATUSES } from 'lib/constants/transaction/completedTransactionStatuses';

/**
 * Beyond Billing reads amount_paid_self straight from SQL (the original amount); other lists get
 * it from the model, net of refunds, so the refunds are added back to show what was charged.
 * A payment that never completed shows what was attempted.
 */
export const resolveAmountPaidSelf = ({ value, data, isFromBB }) => {
  const baseAmount = numOrDefault(value);
  const surcharge = numOrDefault(data?.surcharge_amount);
  const gratuity = numOrDefault(data?.gratuity);
  const totalRefunded =
    numOrDefault(data?.amount_refunded) +
    numOrDefault(data?.surcharge_refunded) +
    numOrDefault(data?.gratuity_refunded);

  const isCompleted = COMPLETED_TRANSACTION_STATUSES.includes(data?.status?.toLowerCase());
  const finalAmount = !isCompleted
    ? numOrDefault(data?.amount_total)
    : isFromBB
      ? baseAmount
      : baseAmount + totalRefunded;

  return { finalAmount, totalRefunded, surcharge, gratuity };
};

// Text form of the AmountPaidSelf cell, so an export carries the same figures the grid shows.
export const formatAmountPaidSelf = (params) => {
  const { finalAmount, totalRefunded } = resolveAmountPaidSelf(params);
  const amount = mString(finalAmount);

  return totalRefunded > 0 ? `${amount} (Refunded: -${mString(totalRefunded)})` : amount;
};
